import React from 'react';
import { PagePath } from '../../../../../../navigation/navigation.enums';
import { Anchor, AvatarIcon, ListItemLayout, ListLayout } from '@keplerco/core';
import managePersonPanelsStyles from '../freemium-manage-person-panels.module.css';
import { FocusPanelLoaderLayer } from '../../../../../../components/general/loading-state/loader-layers/focus-panel-loader-layer/focus-panel-loader-layer';
import { IFreemiumManagePersonFocusPanelProps } from '../freemium-manage-person-panels.models';
import { FreemiumManagePersonDetailsLayout } from './freemium-manage-person-details.layout';

export function FreemiumManagePersonFocusPanel(props: IFreemiumManagePersonFocusPanelProps): JSX.Element {
  return (
    <FocusPanelLoaderLayer path={PagePath.freemiumUserManagementPeople}>
      <div className="panelContent">
        <header className={managePersonPanelsStyles.header}>
          <div className={managePersonPanelsStyles.avatar}>
            <AvatarIcon name={props.person} />
          </div>

          {!!props.person ? (
            <div>
              <h3>
                {props.person.firstName} {props.person.lastName}
              </h3>

              <span className="body">
                <strong>Department</strong> {props.person.departmentName} | <strong>Team</strong> {props.person.teamName}
              </span>
            </div>
          ) : (
            <h3>Add a new person</h3>
          )}
        </header>

        <ListLayout>
          <ListItemLayout>
            <FreemiumManagePersonDetailsLayout person={props.person} onSubmit={props.onSave} />
          </ListItemLayout>
        </ListLayout>

        <footer className="panelFooter">
          <Anchor onClick={props.onCancel}>Cancel</Anchor>
        </footer>
      </div>
    </FocusPanelLoaderLayer>
  );
}
